import React from 'react';
import Icon from '../Izenda.Icon';

function NLQSuggestionList(props) {
  const { showResult, suggestionList, onSelectedSuggestion } = props;
  function renderSuggestionList(suggestionList) {
    return suggestionList.map((suggestion, i) => {
      return (
        <li
          key={i}
          onClick={onSelectedSuggestion.bind(this, suggestion)}
        >
          <Icon className="icon-search" />
          {suggestion.name}
        </li>
      );
    });
  }
  return (
    <div className='search-suggestion-wrapper'>
      {
        !showResult &&
        <ul>
          {renderSuggestionList(suggestionList)}
        </ul>
      }
    </div>
  );
}

export default NLQSuggestionList;



// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQSuggestionBox/Izenda.NLQSuggestionList.js